import React from 'react';

import { transactionsTypes } from 'app-components/flux/transactions';
import type { InvestmentTransactionTxnType } from 'app-components/forms/investment/investmentTransactionForm';
import { VIRTUAL_CASH_FLOW_TXN_TYPE } from 'app-components/forms/investment/investmentTransactionFormDisplay';

import { AddSharesFields } from './AddSharesFields';
import { AmountFields } from './AmountFields';
import { BuyBondsFields } from './BuyBondsFields';
import { CashFlowFields } from './CashFlowFields';
import { ReinvestFields } from './ReinvestFields';
import { SharesFields } from './SharesFields';
import { StockSplitFields } from './StockSplitFields';
import { UnitsOnlyFields } from './UnitsOnlyFields';

export function TypeSpecificFields({
  investmentTxnType,
}: {
  investmentTxnType: InvestmentTransactionTxnType | null | undefined;
}): React.JSX.Element {
  switch (investmentTxnType) {
    case transactionsTypes.InvestmentTxnType.BUY:
    case transactionsTypes.InvestmentTxnType.COVER_SHORT_SELL:
      return <SharesFields expectedSign={-1} />;
    case transactionsTypes.InvestmentTxnType.SELL:
    case transactionsTypes.InvestmentTxnType.SELL_BONDS:
    case transactionsTypes.InvestmentTxnType.SHORT_SELL:
      return <SharesFields expectedSign={1} />;
    case transactionsTypes.InvestmentTxnType.STOCK_DIVIDEND:
      return <UnitsOnlyFields label='Shares quantity' sign={1} />;
    case transactionsTypes.InvestmentTxnType.REINVEST_DIVIDEND:
    case transactionsTypes.InvestmentTxnType.REINVEST_INTEREST:
    case transactionsTypes.InvestmentTxnType.REINVEST_CAPITAL_GAIN_LONG:
    case transactionsTypes.InvestmentTxnType.REINVEST_CAPITAL_GAIN_SHORT:
      return <ReinvestFields />;
    case transactionsTypes.InvestmentTxnType.ADD_SHARES:
      return <AddSharesFields />;
    case transactionsTypes.InvestmentTxnType.REMOVE_SHARES:
      return <UnitsOnlyFields label='Quantity of removed shares' sign={-1} />;
    case transactionsTypes.InvestmentTxnType.BUY_BONDS:
      return <BuyBondsFields />;
    case transactionsTypes.InvestmentTxnType.STOCK_SPLIT:
      return <StockSplitFields />;
    case VIRTUAL_CASH_FLOW_TXN_TYPE:
      return <CashFlowFields />;
    default:
      return <AmountFields />;
  }
}
